import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getIn } from 'formik';

const useStyles = makeStyles((theme) => ({
  attachmentErrorTitle: {
    marginTop: theme.spacing(1),
  },
  errorList: {
    marginTop: 0,
  },
}));

const FormikField = (props) => {
  const { children, field, form, showNoError } = props;
  const classes = useStyles();

  if (showNoError) {
    return [children];
  }

  const touched = getIn(form.touched, field.name);
  const error = getIn(form.errors, field.name);

  if (Array.isArray(error)) {
    return (
      <>
        {children}
        {error.length && (
          <>
            <Typography variant="body2" className={classes.attachmentErrorTitle}>
              Attachment error:
            </Typography>
            <ul className={classes.errorList}>
              {[...new Set(error)].map(
                (value) =>
                  value && (
                    <li key={value}>
                      <FormHelperText error variant="filled">
                        {value}
                      </FormHelperText>
                    </li>
                  ),
              )}
            </ul>
          </>
        )}
      </>
    );
  }

  let currentError;
  if (touched && error) {
    currentError = error;
  }

  return (
    <Fragment>
      {children}
      {currentError && (
        <FormHelperText error variant="filled">
          {currentError}
        </FormHelperText>
      )}
    </Fragment>
  );
};

FormikField.propTypes = {
  children: PropTypes.any.isRequired,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldError: PropTypes.func,
    setFieldValue: PropTypes.func,
    setTouched: PropTypes.func,
  }).isRequired,
  showNoError: PropTypes.bool,
};

FormikField.defaultProps = {
  showNoError: false,
};

export default FormikField;
